export default __webpack_public_path__ + "static/media/guvenlialisveris.be23deb7.png";